import React from 'react';
import { Checkbox } from "@material-ui/core";
import { Alert } from "../controls";
import __ from "lodash";
import moment from 'moment';

const ValidatorColumn = (Validator, hasChildPanel=false, additionalValues=null, useTimeout = true) => {

  return {
    title: "",
    field: "isValid",
    width: 0,
    cellStyle: { width: 0, maxWidth: 0, height: 0, maxHeight: 0, overflow: "hidden", padding: 0 },
    headerStyle: { width: 0, maxWidth: 0, height: 0, maxHeight: 0, overflow: "hidden", padding: 0 },
    sorting: false,
    validate: (rowData) => {
      return rowData.isValid !== false;
    },
    render: (props) => (null),
    editComponent: (props) => {
      const originalData = props.originalData;
      const updatedData = props.rowData;
      return (
        <div style={{ width: 0, maxWidth: 0, height: 0, maxHeight: 0, overflow: "hidden" }}>
          <Validator
            additionalValues={additionalValues}
            data={{ record: updatedData, oldRecord: originalData }}
            onChange={(error) => {
              //change state of invalid as if the user entered it :)              
              const data = { ...props.rowData, isValid: !error.error, errorMessage: error && error.errorMessage ? error.errorMessage : "" }
              if (useTimeout) {
                setTimeout(()=> {
                  props.onRowDataChange(data);
                }, 1);
              } else {
                props.onRowDataChange(data);
              }
            }}
          />
          <div style={{ position: "absolute", width: "100%", marginTop: 25, marginLeft: (hasChildPanel?-42:0) , backgroundColor: "#ffffff", zIndex: 1 }}>
            <Alert
              open={!props.rowData.isValid}
              severity="error"
              canClose={false}
              message={!props.rowData.isValid && props.rowData.errorMessage ? props.rowData.errorMessage : ""}
            />
          </div>
        </div>
      )
    }
  }
}

const ColumnWidth = (width, padding = 2, _maxWidth, cellStyle, headerStyle, filterStyle, removePaddingFromCells = true) => {
  const maxWidth = _maxWidth || width;
  const paddingLeft = Array.isArray(padding)?padding[0]:padding;
  const paddingRight = Array.isArray(padding)?padding[1]:padding;
  let unpaddedColumnWidth = width;
  let unpaddedColumnMaxWidth = maxWidth;
  let editColumnWidth = width - (paddingLeft + paddingRight);
  let editColumnMaxWidth = maxWidth - (paddingLeft + paddingRight);
  if (removePaddingFromCells === true) {
    unpaddedColumnWidth -= (paddingLeft + paddingRight);
    unpaddedColumnMaxWidth -= (paddingLeft + paddingRight);
  }
  if (removePaddingFromCells==="NONE") {
    editColumnWidth = unpaddedColumnWidth;
    editColumnMaxWidth = unpaddedColumnMaxWidth;
  }
  let unpaddedFilterColumnWidth = width - (paddingLeft + paddingRight);
  let unpaddedFilterColumnMaxWidth = maxWidth - (paddingLeft + paddingRight);

  return {
    width: width,
    maxWidth: width,
    minWidth: width,
    cellStyle: { width: unpaddedColumnWidth, minWidth: unpaddedColumnWidth, maxWidth: unpaddedColumnMaxWidth, padding: `8px ${paddingRight}px 8px ${paddingLeft}px`, ...cellStyle },
    editCellStyle: { width: editColumnWidth, minWidth: editColumnWidth, maxWidth: editColumnMaxWidth, padding: `8px ${paddingRight}px 8px ${paddingLeft}px`, ...cellStyle },
    headerStyle: { width: width, minWidth: width, maxWidth: maxWidth, padding: `8px ${paddingRight}px 8px ${paddingLeft}px`, ...headerStyle },
    filterCellStyle: { width: unpaddedFilterColumnWidth, minWidth: unpaddedFilterColumnWidth, maxWidth: unpaddedFilterColumnMaxWidth, padding: `8px ${paddingRight}px 8px ${paddingLeft}px`, ...filterStyle },
  }
}

const renderBooleanFilter = (props) => {
  const {columnDef} = props;
  return (
  <Checkbox
    indeterminate={columnDef.tableData.filterValue === undefined}
    checked={columnDef.tableData.filterValue === "checked"}
    size={props.size}
    onChange={(event) => {
      let val;
      if (columnDef.tableData.filterValue === undefined) {
        val = "checked";
      } else if (columnDef.tableData.filterValue === "checked") {
        val = "unchecked";
      }
      props.onFilterChanged(columnDef.tableData.id, val);
    }}
  />
)};

const dateSearch = (fieldname) => {
  return  (term, rowData) => {
    const termUpper = `${term}`.toUpperCase();
    if (!__.has(rowData, fieldname)) return __.isEmpty(term);
    const dateField = rowData[fieldname];
    if (!moment.utc(dateField).isValid()) return __.isEmpty(term);

    let formattedDate = moment.utc(dateField).format('DD/MM/YYYY');
    console.log(formattedDate);
    if (`${formattedDate}`.toUpperCase() === termUpper) return true;

    formattedDate = moment.utc(dateField).format('DD/MM');
    console.log(formattedDate);
    if (`${formattedDate}`.toUpperCase() === termUpper) return true;

    formattedDate = moment.utc(dateField).format('D MMM');
    console.log(formattedDate);
    if (`${formattedDate}`.toUpperCase() === termUpper) return true;

    formattedDate = moment.utc(dateField).format('DD MMM');
    console.log(formattedDate);
    if (`${formattedDate}`.toUpperCase() === termUpper) return true;

    return false;
  }
}

const dowSearch = (fieldName) => {
  return  (term, rowData) => {
    const termUpper = `${term}`.toUpperCase();
    const dayName = `${moment().isoWeekday(rowData.dow)}`.toUpperCase();
    return dayName.startsWith(termUpper);
  }
}

const dowNumberSearch = (fieldName) => {
  return  (term, rowData) => {
    if (!__.has(rowData, fieldName)) return __.isEmpty(term);
    const dayNumber = moment(rowData[fieldName]).isoWeekday().toString();
    return dayNumber === term;
  }
}

export {
  ValidatorColumn,
  ColumnWidth,
  renderBooleanFilter,
  dateSearch,
  dowSearch,
  dowNumberSearch
};
